import { ReactNode } from "react";
import { Alert } from "antd";
import { InfoCircleFilled } from "@ant-design/icons";

import style from "./style.module.css";

/**
 * The house "Note" callout — a grey, borderless antd Alert with a primary-tinted icon and a bold
 * title.
 *
 * @param {object} props - Component props.
 * @param {string} [props.title] - Heading shown beside the icon.
 * @param {ReactNode[]} [props.items] - Rendered as a bulleted list; omit to render `children` as-is.
 * @param {ReactNode} [props.children] - Free-form body, used when `items` is not given.
 * @param {string} [props.className] - Appended to the note's own class for per-view spacing.
 * @returns {JSX.Element} The note.
 */
export function InfoNote({
  title = "Note",
  items,
  children,
  className,
}: {
  title?: string;
  items?: ReactNode[];
  children?: ReactNode;
  className?: string;
}) {
  return (
    <Alert
      type="info"
      showIcon={true}
      icon={<InfoCircleFilled className={style.infoNoteIcon} />}
      className={className ? `${style.infoNote} ${className}` : style.infoNote}
      message={<span className={style.infoNoteTitle}>{title}</span>}
      description={
        items ? (
          <ul className={style.infoNoteList}>
            {items.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        ) : (
          children
        )
      }
    />
  );
}
